module.exports = __webpack_public_path__ + "static/3.7880cd9f.png";


//////////////////
// WEBPACK FOOTER
// D:/Workarea/iota.org/documentation/src/assets/3.png
// module id = 216
// module chunks = 1